import Footer from "../Components/Footer/Footer";
import Footer2 from "../Components/Footer/Footer2";
import TheCrypt from "../Components/HomePage/Crypt/TheCrypt";
import { Helmet } from "react-helmet";
import { getAnalytics, logEvent } from "firebase/analytics";
import ShopByCategories from "../Components/HomePage/ShopbyCategories/ShopByCategories";
import { useSelector } from "react-redux";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import { db } from "../utils/firebase/firebase.utils";
import TopPicks from "../Components/HomePage/TopPicks/TopPicks";
import DesignerBrand from "../Components/HomePage/DesignerBrand/DesignerBrand";
import JustViewed from "../Components/HomePage/JustViewed/JustViewed";
import NavBar from "../Components/NavBar";
import Banner from "../Components/HomePage/section0/Banner.js";
import Header from "../Components/HomePage/section1/Header.js";
import TrustSection from "../Components/HomePage/Trust/Trust.js";
import ImageSection from "../Components/HomePage/2ImageSection/2ImageSection.js";
import WeTrust from "../Components/HomePage/WeTrust/WeTrust.js";
import TabBottom from "../Components/TabBottom.js";
import banner1phone from "../assets/images/home/c2 (1).webp";
import BannerMobile from "../Components/HomePage/section1/BannerMobile.jsx";
import { UserContext } from "../context/user.context.jsx";
import CookiesConsent from "../Components/CookiesConsent.jsx";

function LandingPage() {
  // State management
  const [showBanner, setShowBanner] = useState(false);
  const [orders, setOrders] = useState(0);
  const [showSection, setShowSection] = useState(false);
  const [bannerChecked, setBannerChecked] = useState(false);

  // Context and selectors
  const { currentUser } = useContext(UserContext);
  const { constant } = useSelector((store) => store.flags);

  // Refs
  const targetDivRef = useRef(null);

  // Analytics
  const analytics = getAnalytics();

  // Memoized functions
  const getOrders = useCallback(async () => {
    try {
      const ordersRef = collection(db, "orders");
      const querySnapshot = await getDocs(query(ordersRef));
      setOrders(querySnapshot.docs.length);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  }, []);

  const checkCouponUsage = useCallback(async () => {
    try {
      if (!currentUser) {
        setShowBanner(true);
        setBannerChecked(true);
        return;
      }

      const couponId = "ajEMNqlua8IZgwUbUMJs";
      const ordersRef = collection(db, "orders");
      const q = query(
        ordersRef,
        where("idUser", "==", currentUser?.uid),
        where("couponId", "==", couponId)
      );

      // Add cache control to bypass cache when needed
      const querySnapshot = await getDocs(q, {
        source: bannerChecked ? "cache" : "server",
      });

      const hasUsedCoupon = !querySnapshot.empty;
      setShowBanner(!hasUsedCoupon);
      setBannerChecked(true);

      // If coupon was used, ensure banner stays hidden
      if (hasUsedCoupon) {
        localStorage.setItem("hideWelcomeBanner", "true");
      }
    } catch (error) {
      console.error("Error checking coupon usage:", error);
    }
  }, [currentUser, bannerChecked]);

  // Effects
  useEffect(() => {
    logEvent(analytics, "page_view", {
      firebase_screen: "Home Page",
    });
  }, [analytics]);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  // Check coupon usage more frequently
  useEffect(() => {
    checkCouponUsage();

    // Add event listener for route changes
    const handleRouteChange = () => {
      setBannerChecked(false); // Force recheck on route change
      checkCouponUsage();
    };

    window.addEventListener("popstate", handleRouteChange);
    return () => window.removeEventListener("popstate", handleRouteChange);
  }, [checkCouponUsage]);

  // Check localStorage for manual hide
  useEffect(() => {
    const shouldHide = localStorage.getItem("hideWelcomeBanner");
    if (shouldHide === "true") {
      setShowBanner(false);
    }
  }, []);

  // Check coupon usage when user changes
  useEffect(() => {
    if (currentUser) {
      setBannerChecked(false);
      checkCouponUsage();
    }
  }, [currentUser, checkCouponUsage]);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    setShowSection(!!hasVisited);

    if (!hasVisited) {
      localStorage.setItem("hasVisited", "true");
    }

    // Load Google Tag Manager scripts
    const loadGTM = () => {
      if (window.dataLayer) return; // Already loaded

      const script1 = document.createElement("script");
      script1.src =
        "https://www.googletagmanager.com/gtag/js?id=AW-11517267669";
      script1.async = true;

      const script2 = document.createElement("script");
      script2.innerHTML = `
         window.dataLayer = window.dataLayer || [];
         function gtag(){dataLayer.push(arguments);}
         gtag('js', new Date());
         gtag('config', 'AW-11517267669');
       `;

      document.head.appendChild(script1);
      document.head.appendChild(script2);
    };

    loadGTM();
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Libas makes buying and selling pre-loved luxury easy and secure. Connect with a fashion-forward community and explore a curated selection of preloved designer items.
          "
        />
        <title>Libas: Buy & sell pre-loved designer bags, shoes, clothes</title>
        <meta
          name="title"
          content="Libas: Buy & sell pre-loved designer bags, shoes, clothes"
          data-react-helmet="true"
        />
        <meta
          property="og:image"
          content="https://libas.ae/icon.png"
          data-react-helmet="true"
        />
        <meta
          property="og:url"
          content="https://libas.ae/"
          data-react-helmet="true"
        />
        <meta property="og:type" content="website" data-react-helmet="true" />
        <meta
          property="og:title"
          content="Libas: Buy & sell pre-loved designer bags, shoes, clothes"
          data-react-helmet="true"
        />
        <meta
          property="og:description"
          content="Find luxury for less on Libas. Browse a curated collection of pre-loved designer fashion and connect with a community that values style and sustainability."
          data-react-helmet="true"
        />
        <link rel="preload" as="image" href={banner1phone} />
      </Helmet>

      {/* <div className='row   mx-0 '>
    <div className='col-12  px-0'> */}
      {/* <NavBar/> */}

      <NavBar />
      {/* Cookies consent */}
      <CookiesConsent />
      {/* <GifSection targetDivRef={targetDivRef}/> */}
      <div className="row mx-0 ">
        <div className="col-12 h-100 px-md-4 px-3">
          <div className="d-md-block d-none  px-3">
            {/* sliding banner homepage */}
            <Header />
          </div>
          {/* for mobile */}
          {showBanner && (
            <div className="d-md-none d-block px-0 ">
              <BannerMobile />
            </div>
          )}

          {showSection ? (
            <div className=" pt-2 ">
              <WeTrust />
            </div>
          ) : null}
          <div className="pt-2  pt-md-5 pt-4" ref={targetDivRef}>
            <ShopByCategories />
          </div>
          {/* <div  className='pt-2   px-0 pt-md-5 pt-4' >
      <DownloadLibas/>
      </div> */}
          {/* <div  className='pt-2   px-0 pt-md-4 pt-4' >
      <AsleAi/>
      </div> */}
          {/* <div  className='pt-2   px-0 pt-md-5 pt-3' >
      <Authentication/>
      </div> */}
          {/* <div  className='pt-2   px-0 pt-md-5 pt-3' >
      <Mission/>
      </div> */}
          {/* <ImpactNumber orders={orders}/> */}
          {/* <div  className=' px-md-4 px-0'  >
      <TheCrypt/>
      </div> */}
          <div className="pt-2  pt-md-5 pt-4">
            <TopPicks />
          </div>

          {/* <div  className='pt-2  px-md-4 px-0'>
      <CremeDeLaCreme/>
      </div> */}

          <br></br>
          {/* <div  className='pt-2   px-0 pt-md-5 pt-3' >
      <SellWithUs/>
      <WhySellOnLibas/>
      </div> */}

          {/* Watch/Women collection Cards */}
          <div className="pt-2 pb-2 ">
            <ImageSection />
          </div>

          <div className="pt-2 pb-2 ">
            <DesignerBrand />
          </div>

          {/* <div  className='pt-2  px-md-4 px-0' >
      <DesignerBrand/>
      </div> */}
          <div className=" pt-2 ">
            <JustViewed />
          </div>

          <div className=" pt-2">
            <TheCrypt />
          </div>

          {/* { constant==undefined||constant.isReferralAvailable==undefined?null:
        constant.isReferralAvailable==true&&
         <div  className='pt-2  px-md-4 px-0   pt-lg-5 pt-4 '>
         <ReferalHomePage/>
         </div>
} */}

          {/* <div  className='  px-md-4 px-0 '>
      <NewDrops/>
      </div>  */}
          {/* <div>
        <Shared2/>
       </div> */}
        </div>

        <TrustSection />
        <Footer />
        <Footer2 />

        <TabBottom />
      </div>

      {/* </div>
     </div> */}
    </>
  );
}

export default LandingPage;
